export enum CUSTOMER_SETTINGS {
    /**
     * @value Advanced settings
     */
    ADVANCED_SETTINGS = 'ADMIN.INSTANCE.ADVANCED_SETTINGS',
    /**
     * @value Available languages
     */
    AVAILABLE_LANGS = 'AVAILABLE_LANGS',
    /**
     * @value Beta Features
     */
    BETA_FEATURES = 'ADVANCED.SETTINGS.BETA_FEATURES',
    /**
     * @value Define which users are able to apply any kind of html tags
     */
    BLOCK_XSS_HTML_TAGS = 'BLOCK_XSS_HTML_TAGS',
    /**
     * @value Enable browser translation
     * @description Setting displayed in "Advanced settings" of "Platform settings"
     */
    BROWSER_TRANSLATION = 'BROWSER_TRANSLATION',
    /**
     * @value Comments
     */
    COMMENTS = 'REPORTS.COMMENT_RESOURCE_TYPE_FILTER',
    /**
     * @value Displayed filter widget information (community)
     */
    COMMUNITY_FILTERS = 'COMMUNITY_FILTERS',
    /**
     * @value Displayed content list widget information
     */
    CONTENT_FIELDS = 'CONTENT_FIELDS',
    /**
     * @value Displayed filter widget information (content)
     */
    CONTENT_FILTERS = 'CONTENT_FILTERS',
    /**
     * @value Content excerpt truncate
     */
    CONTENT_LIST_EXCERPT = 'CONTENT_LIST_EXCERPT',
    /**
     * @value In content list widget, always open in a new tab content from other sites
     */
    CONTENT_LIST_LINK_OPEN_NEW_TAB = 'CONTENT_LIST_LINK_OPEN_NEW_TAB',
    /**
     * @value Customization
     */
    CUSTOMIZATION = 'ADMIN.NAV.MOBILE_SETTINGS_CUSTOMIZATION',
    /**
     * @value Allow anonymous execution of customizations
     */
    CUSTOMIZATIONS = 'ADMIN.FEATURES.PUBLIC_JS_CUSTOMIZATIONS.NAME',
    /**
     * @value This feature is optional, you are not required to activate it and its use is entirely at your own risk. The use of this feature may cause the Application to behave erratically and pose security risks. We strongly recommend that you contact your IT and security departments before activating it. LumApps maintains no oversight or control over this feature's application.
     */
    CUSTOMIZATIONS_WARNING = 'CUSTOMER_SETTINGS.PUBLIC_CUSTOMIZATIONS_WARNING',
    /**
     * @value Displayed filter widget information (directory)
     */
    DIRECTORY_FILTERS = 'DIRECTORY_FILTERS',
    /**
     * @value Available default languages
     */
    FALLBACK_LANGS = 'FALLBACK_LANGS',
    /**
     * @value Displayed file list widget information
     */
    FILE_FIELDS = 'FILE_FIELDS',
    /**
     * @value Displayed metadata widget information
     */
    META_FIELDS = 'META_FIELDS',
    /**
     * @value Displayed social metadata widget information
     */
    META_SOCIAL_FIELDS = 'META_SOCIAL_FIELDS',
    /**
     * @value All content contributors and admins
     */
    PLATFORM_SETTINGS_HTML_WHITELIST_ALL = 'PLATFORM_SETTINGS_HTML_WHITELIST_ALL',
    /**
     * @value Only global administrators
     */
    PLATFORM_SETTINGS_HTML_WHITELIST_PLATFORM = 'PLATFORM_SETTINGS_HTML_WHITELIST_PLATFORM',
    /**
     * @value Administrators and global widget creators
     */
    PLATFORM_SETTINGS_HTML_WHITELIST_SITE = 'PLATFORM_SETTINGS_HTML_WHITELIST_SITE',
    /**
     * @value Displayed post list widget information
     */
    POST_FIELDS = 'POST_FIELDS',
    /**
     * @value Social features settings
     */
    SOCIAL_SETTINGS = 'SOCIAL_SETTINGS',
    /**
     * @value Enable Post sharing
     */
    SOCIAL_SETTINGS_MULTIPOSTING_ALLOWED = 'SOCIAL_SETTINGS_MULTIPOSTING_ALLOWED',
    /**
     * @value Directory field displayed below user name
     */
    USER_BLOCK_DEFAULT_FIELD = 'USER_BLOCK_DEFAULT_FIELD',
    /**
     * @value Directory field displayed below user name in directory module
     */
    USER_BLOCK_USER_DIRECTORY_FIELD = 'USER_BLOCK_USER_DIRECTORY_FIELD',
    /**
     * @value Publication date
     */
    WIDGET_TYPE_CONTENT_FILTER_DATES = 'WIDGET_TYPE_CONTENT-FILTER_DATES',
    /**
     * @value Tags
     */
    WIDGET_TYPE_CONTENT_FILTER_DIRECTORY_TAGS = 'WIDGET_TYPE_CONTENT-FILTER_DIRECTORY-TAGS',
    /**
     * @value Social
     */
    WIDGET_TYPE_CONTENT_LIST_SOCIAL = 'WIDGET_TYPE_CONTENT-LIST_SOCIAL',
    /**
     * @value Comment button
     */
    WIDGET_TYPE_META_SOCIAL_COMMENT = 'WIDGET_TYPE_META-SOCIAL_COMMENT',
    /**
     * @value Follow button
     */
    WIDGET_TYPE_META_SOCIAL_FOLLOW = 'WIDGET_TYPE_META-SOCIAL_FOLLOW',
    /**
     * @value Like button
     */
    WIDGET_TYPE_META_SOCIAL_LIKE = 'WIDGET_TYPE_META-SOCIAL_LIKE',
    /**
     * @value Attachments
     */
    WIDGET_TYPE_POST_LIST_ATTACHMENTS = 'WIDGET_TYPE_POST-LIST_ATTACHMENTS',
    /**
     * @value Event dates
     */
    WIDGET_TYPE_POST_LIST_DATES = 'WIDGET_TYPE_POST-LIST_DATES',
    /**
     * @value Visibility
     */
    WIDGET_TYPE_POST_LIST_SHARED_IN_COMMUNITIES = 'WIDGET_TYPE_POST-LIST_SHAREDINCOMMUNITIES',
    /**
     * @value HTML editor (HTML Content widget)
     */
    WYSIWYG = 'ADVANCED.SETTINGS.WYSIWYG',
    /**
     * @value Always paste plain text in html widget
     */
    WYSIWYG_PASTEPLAIN = 'WYSIWYG_PASTEPLAIN',
    /**
     * @value Editor content toolbar
     */
    WYSIWYG_TOOLBAR = 'WYSIWYG_TOOLBAR',
}
